/* eslint-disable max-len */
import cn from 'classnames';
import { memo } from 'react';

import { filterContent } from '../../utils/filters/vacancyContentFilter';
import { getSalaryBracketFromArray } from '../../utils/get-salary-bracket';
import { getWorkXPFromNumber } from '../../utils/get-work-xp-from-number';
import classes from './vacancy-summary.module.scss';

interface IVacancySummaryProps {
  data: ReturnType<typeof filterContent>[1];
  archivedAt?: string | null | undefined;
  isArchived?: boolean;
}

function VacancySummary({
  data: rawData,
  isArchived,
  archivedAt,
}: IVacancySummaryProps) {
  const salaryBracket = rawData.find(([key]) => key === 'salaryBracket')?.[1];
  const workExperience = rawData.find(([key]) => key === 'workExperience')?.[1];
  const data = rawData
    .filter(([key]) => key !== 'salaryBracket' && key !== 'workExperience')
    .map(([, item]) => item);

  if (!rawData || rawData.length === 0) {
    return null;
  }

  return (
    <div className={classes.container}>
      <div
        className={cn({
          [classes.summary]: true,
          [classes.summaryDefault]: true,
        })}
      >
        {isArchived && (
          <div className={classes.summaryArchive}>
            В архиве
            {' '}
            {archivedAt && (
              <>
                с
                {' '}
                {new Intl.DateTimeFormat('ru-RU', {
                  dateStyle: 'long',
                })
                  .format(new Date(archivedAt))
                  .slice(0, -3)}
              </>
            )}
          </div>
        )}

        {!!workExperience?.value && !Array.isArray(workExperience.value) && (
          <div
            key={workExperience.displayName}
            style={{ order: workExperience.order }}
          >
            <div className={classes.displayName}>
              {workExperience.displayName}
            </div>
            <div className={classes.value}>
              {getWorkXPFromNumber(workExperience.value)}
            </div>
          </div>
        )}
        {!!salaryBracket?.value
          && Array.isArray(salaryBracket?.value)
          && getSalaryBracketFromArray(salaryBracket.value) !== 0 && (
            <div
              key={salaryBracket.displayName}
              style={{ order: salaryBracket.order }}
            >
              <div className={classes.displayName}>
                {salaryBracket.displayName}
              </div>
              <div className={classes.value}>
                {getSalaryBracketFromArray(salaryBracket.value)}
              </div>
            </div>
        )}
        {data
          && data.map(
            (item) => typeof item === 'object'
              && item.value && (
                <div key={item.displayName} style={{ order: item.order }}>
                  <div className={classes.displayName}>{item.displayName}</div>
                  <div className={classes.value}>
                    {!Array.isArray(item.value) && item.value}
                    {Array.isArray(item.value)
                      && item.value.map((element) => (
                        <p className={classes.value}>{element}</p>
                      ))}
                  </div>
                </div>
            ),
          )}
      </div>
    </div>
  );
}

export default memo(VacancySummary);
